import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Layout, Menu, Tooltip, Typography, Button, notification } from "antd";
import {
	LockFilled,
	UserOutlined,
	EnvironmentOutlined,
	DashboardOutlined,
	BranchesOutlined,
	AppstoreOutlined,
	DollarCircleOutlined,
	SolutionOutlined,
	SafetyCertificateOutlined,
	ExclamationCircleOutlined,
	FileTextOutlined,
	EditFilled,
	SettingOutlined,
	TeamOutlined,
	ApartmentOutlined,
	AppstoreAddOutlined,
	ContactsOutlined,
	TagOutlined,
	UsergroupAddOutlined,
	FormOutlined,
	CheckOutlined,
	ProfileOutlined,
	LogoutOutlined,
	ApiOutlined,
	UserSwitchOutlined,
	KeyOutlined,
	BellOutlined,
	MenuUnfoldOutlined,
	MenuFoldOutlined,
	SwapOutlined,
} from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import ProfilePictureComponent from "./../profilePicture";
import impersonate from "../../services/impersonate";
import { loginStart, loginSuccess, loginFailure } from "../../redux/userSlice";

const { Sider, Content } = Layout;
const { SubMenu } = Menu;

const DefaultLayout = ({ children }) => {
	const initialCollapsed =
		localStorage.getItem("menuCollapsed") === "true" ? true : false;
	const [collapsed, setCollapsed] = useState(initialCollapsed);
	const [isVisible, setIsVisible] = useState(true);
	const { currentUser } = useSelector((state) => state.user);
	const location = useLocation();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	// FOR MOBILE
	const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
	const [isMobile, setIsMobile] = useState(window.innerWidth < 900);

	useEffect(() => {
		const handleResize = () => {
			const isNowMobile = window.innerWidth < 900;
			setIsMobile(isNowMobile);
			if (!isNowMobile) setMobileMenuOpen(false); // close overlay on desktop
		};
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);
	// FOR MOBILE

	// Fix: Prevent error if currentUser is null
	const impersonateUser =
		currentUser && currentUser.impersonated_user === true ? true : false;

	useEffect(() => {
		const handleResize = () => {
			if (window.innerWidth < 900 && !collapsed) {
				setCollapsed(true);
				setIsVisible(false);
			} else if (window.innerWidth >= 900 && collapsed) {
				setCollapsed(false);
				setIsVisible(true);
			}
		};
		window.addEventListener("resize", handleResize);
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, [collapsed]);

	const switchBack = async () => {
		console.log("yes here clicked on switch back");
		dispatch(loginStart());
		try {
			const response = await impersonate.impersonateStop();
			console.log("yeh haiii ", response);
			if (response.current_user) {
				response.current_user.token = response.current_user.token;
				localStorage.setItem("token", response.current_user?.token);

				console.log(response.current_user.token);

				dispatch(loginSuccess(response.current_user));
				notification.success({
					message: "Account Switched",
					description: response.message,
				});
			}
		} catch (error) {
			dispatch(loginFailure());
			console.log(error);
			notification.error({
				message: "Error",
				description: error,
			});
		} finally {
		}
	};

	useEffect(() => {
		localStorage.setItem("menuCollapsed", collapsed);
	}, [collapsed]);

	const handleLogout = () => {
		// localStorage.clear();
		localStorage.removeItem("token");
		localStorage.removeItem("persist:root");
		window.location.href = "/login";
	};

	useEffect(() => {
		if (location.state && location.state.prevUrl) {
			navigate(location.state.prevUrl, { replace: true });
		}
	}, [location, navigate]);

	// Convert menu item objects to AntD v5 format
	const renderMenuItems = (items) => {
		return items.map((item) => ({
			key: item.id || `${item.key}-${item.route}`,
			icon: item.icon,
			label: <Link to={item.route}>{item.label}</Link>,
		}));
	};

	const userManagement = [
		{
			key: "Role",
			icon: <ApartmentOutlined />,
			label: "Roles",
			route: "/roles",
		},
		{
			key: "User",
			icon: <UserOutlined />,
			label: "User Data",
			route: "/users",
		},
		{
			key: "User",
			icon: <UserOutlined />,
			label: "Restore Users",
			route: "/restore-users",
		},
		{
			key: "ParallelApprover",
			icon: <UserSwitchOutlined />,
			label: "Parallel Approvers",
			route: "/parallel-approvers",
		},
	];

	const formMenuItems = [
		{
			key: "SoftwareChangeRequestForm",
			icon: <FileTextOutlined />,
			label: "Software Change Request Form",
			route: "/scrf",
		},
		{
			key: "CapitalRequestForm",
			icon: <SolutionOutlined />,
			label: "Capital Request Form",
			route: "/crf",
		},
		{
			key: "QualityAssurance",
			icon: <SafetyCertificateOutlined />,
			label: "Quality Assurance Form",
			route: "/quality-assurance",
		},
		{
			key: "Deployment",
			icon: <ExclamationCircleOutlined />,
			label: "Deployment Form",
			route: "/deployment",
		},

		{
			key: "MobileRequisition",
			icon: <ExclamationCircleOutlined />,
			label: "Mobile Requisition Form",
			route: "/mobile-requisition",
		},
		{
			key: "MasterDataManagementForm",
			icon: <ExclamationCircleOutlined />,
			label: "Master Data Management Form",
			route: "/master-data-management-form",
		},
		// {
		//   key: "MasterDataManagementForm",
		//   icon: <ExclamationCircleOutlined />,
		//   label: "Deployment Form",
		//   route: "/deployment",
		// },
		{
			key: "SapAccessForm",
			icon: <FileTextOutlined />,
			label: "SAP Access Form",
			route: "/sap-access-form",
		},
		{
			key: "RequestSupportForm",
			icon: <AppstoreAddOutlined />,
			label: "Request Support Form",
			route: "/request-support-form",
		},
	];

	const configPermissionMenuItems = [
		{
			key: "CostCenter",
			icon: <DollarCircleOutlined />,
			label: "Cost Center",
			route: "/cost-center",
		},
		{
			key: "CostCenter",
			icon: <AppstoreAddOutlined />,
			label: "MDM Project",
			route: "/mdm-project",
		},
		{
			key: "CrfSetting",
			icon: <DollarCircleOutlined />,
			label: "Crf Settings",
			route: "/crf-settings",
		},

		{
			key: "Equipment",
			icon: <ApiOutlined />,
			label: "Equipments",
			route: "/equipments",
		},
	];

	const serviceDeskMenuItems = [
		{
			key: "ServiceDesk",
			icon: <BellOutlined />,
			label: "Service Desk",
			route: "/service-desk",
		},
		{
			key: "RequestSupportDesk",
			icon: <BellOutlined />,
			label: "Request Support Desk",
			route: "/request-support-desk",
		},
		{
			key: "AssignTask",
			icon: <UserSwitchOutlined />,
			label: "Assigned Tasks",
			route: "/assign-task",
		},
		{
			key: "AutoAssignTask",
			icon: <UserSwitchOutlined />,
			label: "Auto Assign Task",
			route: "/auto-assign-task",
		},
		{
			key: "GlobalSearch",
			icon: <AppstoreAddOutlined />,
			label: "Global Search",
			route: "/global-search",
		},
		{
			key: "RequestDelete",
			icon: <AppstoreAddOutlined />,
			label: "Delete Request",
			route: "/request-delete",
		},
	];

	const menuItems = [
		{
			key: "Department",
			icon: <TeamOutlined />,
			label: "Departments",
			route: "/departments",
		},
		{
			key: "DependentCrud",
			icon: <AppstoreAddOutlined />,
			label: "Parameters",
			route: "/params",
		},
		{
			key: "Project",
			icon: <AppstoreAddOutlined />,
			label: "Projects",
			route: "/projects",
		},
		{
			key: "Section",
			icon: <AppstoreAddOutlined />,
			label: "Sections",
			route: "/sections",
		},
		{
			key: "SoftwareCategory",
			icon: <TagOutlined />,
			label: "Categories",
			route: "/categories",
		},
		{
			key: "SoftwareSubcategory",
			icon: <AppstoreOutlined />,
			label: "Subcategories",
			route: "/software-subcategories",
		},
		{
			key: "Designation",
			icon: <ContactsOutlined />,
			label: "Designations",
			route: "/designations",
		},
		{
			key: "Location",
			icon: <EnvironmentOutlined />,
			label: "Locations",
			route: "/locations",
		},
		{
			key: "BusinessExpert",
			icon: <TeamOutlined />,
			label: "Business Expert",
			route: "/business-expert",
		},
		{
			key: "Subscribers",
			icon: <UsergroupAddOutlined />,
			label: "Subscribers",
			route: "/subscribers",
		},
		{
			key: "Approvers",
			icon: <CheckOutlined />,
			label: "Approvers",
			route: "/approvers",
		},
		{
			key: "Department",
			icon: <AppstoreAddOutlined />,
			label: "Makes",
			route: "/makes",
		},
		{
			key: "MdmCategory",
			icon: <AppstoreAddOutlined />,
			label: "Mdm Categories",
			route: "/mdm-categories",
		},
		{
			key: "MdmCategory",
			icon: <AppstoreAddOutlined />,
			label: "Companies",
			route: "/companies",
		},
		{
			key: "Service",
			icon: <AppstoreAddOutlined />,
			label: "Services",
			route: "/services",
		},
		{
			key: "DepartmentService",
			icon: <AppstoreAddOutlined />,
			label: "Link Services with Department",
			route: "/department-services",
		},
		{
			key: "ServiceTeam",
			icon: <AppstoreAddOutlined />,
			label: "Link Teams with Service",
			route: "/service-teams",
		},
		// {
		//   key: "Service",
		//   icon: <AppstoreAddOutlined />,
		//   label: "Parameters",
		//   route: "/params",
		// },
	];

	const allowedPermissions =
		currentUser?.["roles.permission"]?.map((permission) => permission.name) ||
		[];
	//console.log(allowedPermissions)
	const filteredMenuItems = menuItems.filter((item) =>
		allowedPermissions.includes(`${item.key}-view`)
	);
	const filteredUserManagementItems = userManagement.filter((item) =>
		allowedPermissions.includes(`${item.key}-view`)
	);
	const filteredConfigurationMenuItems = configPermissionMenuItems.filter(
		(item) => allowedPermissions.includes(`${item.key}-view`)
	);
	const filteredServiceDeskMenuItems = serviceDeskMenuItems.filter((item) =>
		allowedPermissions.includes(`${item.key}-view`)
	);
	const filteredFormMenuItems = formMenuItems.filter((item) =>
		allowedPermissions.includes(`${item.key}-view`)
	);

	// AntD v5 Menu expects items prop, not children
	// Build menu structure for desktop
	const desktopMenuItems = [
		{
			key: "dashboard",
			icon: <DashboardOutlined />,
			label: <Link to='/dashboard'>Dashboard</Link>,
		},
		filteredUserManagementItems.length > 0 && {
			key: "userManagement",
			icon: <BranchesOutlined />,
			label: "USER MANAGEMENT",
			popupClassName: "scrollable-submenu",
			children: renderMenuItems(filteredUserManagementItems),
		},
		filteredConfigurationMenuItems.length > 0 && {
			key: "configurations",
			icon: <KeyOutlined />,
			label: "CONFIGURATIONS",
			popupClassName: "scrollable-submenu",
			children: [
				...renderMenuItems(filteredConfigurationMenuItems),
				...(currentUser?.roles?.includes("admin")
					? [
							{
								key: "admin-forms",
								icon: <FormOutlined />,
								label: <Link to='/forms'>Forms</Link>,
							},
							{
								key: "admin-formPermissions",
								icon: <KeyOutlined />,
								label: <Link to='/form-permissions'>Form Permissions</Link>,
							},
							{
								key: "assignPermissionLink",
								icon: <UserSwitchOutlined />,
								label: (
									<Link to='/assign-permission'>Assign Form Permissions</Link>
								),
							},
							{
								key: "workflowLink",
								icon: <ProfileOutlined />,
								label: <Link to='/workflow'>Workflow</Link>,
							},
							{
								key: "withoutWorkflow",
								icon: <ProfileOutlined />,
								label: <Link to='/without_workflow'>Without Workflow</Link>,
							},
							{
								key: "team-group",
								icon: <SolutionOutlined />,
								label: <Link to='/team-group '>Create Team</Link>,
							},
							{
								key: "team-member",
								icon: <SolutionOutlined />,
								label: <Link to='/team-member '>Assign Team Members</Link>,
							},
							{
								key: "settings",
								icon: <SettingOutlined />,
								label: <Link to='/settings '>System Settings</Link>,
							},
							{
								key: "customize",
								icon: <SettingOutlined />,
								label: <Link to='/customize '>Theme Customizer</Link>,
							},
					  ]
					: []),
			],
		},
		filteredMenuItems.length > 0 && {
			key: "SETUP FIELDS",
			icon: <BranchesOutlined />,
			label: "SETUP FIELDS",
			popupClassName: "scrollable-submenu",
			children: renderMenuItems(filteredMenuItems),
		},
		filteredFormMenuItems.length > 0 && {
			key: "FORMS",
			icon: <FormOutlined />,
			label: "FORMS",
			popupClassName: "scrollable-submenu",
			children: renderMenuItems(filteredFormMenuItems),
		},
	].filter(Boolean);

	// Service Desk menu for desktop (separate menu)
	const serviceDeskMenu =
		filteredServiceDeskMenuItems.length > 0
			? [
					{
						key: "SERVICE DESK",
						icon: <BranchesOutlined />,
						label: "SERVICE DESK",
						children: renderMenuItems(filteredServiceDeskMenuItems),
					},
			  ]
			: [];

	// Collapsed-only menu items for desktop
	const collapsedMenuItems = [
		{
			key: "profile",
			icon: <EditFilled />,
			label: (
				<Link to='/profile' className='fs-16 mr-4'>
					profile
				</Link>
			),
		},
		{
			key: "password",
			icon: <LockFilled />,
			label: (
				<Link to='/password' className='fs-16 mr-4'>
					Password
				</Link>
			),
		},
		{
			key: "dashboard",
			icon: <LogoutOutlined />,
			label: <Link onClick={handleLogout}>Logout</Link>,
		},
	];

	// Mobile menu items
	const mobileMenuItems = [
		{
			key: "dashboard",
			icon: <DashboardOutlined />,
			label: <Link to='/dashboard'>Dashboard</Link>,
		},
		filteredUserManagementItems.length > 0 && {
			key: "userMobile",
			icon: <BranchesOutlined />,
			label: "User Management",
			children: renderMenuItems(filteredUserManagementItems),
		},
		filteredConfigurationMenuItems.length > 0 && {
			key: "configurations",
			icon: <KeyOutlined />,
			label: "CONFIGURATIONS",
			popupClassName: "scrollable-submenu",
			children: [
				...renderMenuItems(filteredConfigurationMenuItems),
				...(currentUser?.roles?.includes("admin")
					? [
							{
								key: "admin-forms",
								icon: <FormOutlined />,
								label: <Link to='/forms'>Forms</Link>,
							},
							{
								key: "admin-formPermissions",
								icon: <KeyOutlined />,
								label: <Link to='/form-permissions'>Form Permissions</Link>,
							},
							{
								key: "assignPermissionLink",
								icon: <UserSwitchOutlined />,
								label: (
									<Link to='/assign-permission'>Assign Form Permissions</Link>
								),
							},
							{
								key: "workflowLink",
								icon: <ProfileOutlined />,
								label: <Link to='/workflow'>Workflow</Link>,
							},
							{
								key: "withoutWorkflow",
								icon: <ProfileOutlined />,
								label: <Link to='/without_workflow'>Without Workflow</Link>,
							},
							{
								key: "team-group",
								icon: <SolutionOutlined />,
								label: <Link to='/team-group '>Create Team</Link>,
							},
							{
								key: "team-member",
								icon: <SolutionOutlined />,
								label: <Link to='/team-member '>Assign Team Members</Link>,
							},
							{
								key: "settings",
								icon: <SettingOutlined />,
								label: <Link to='/settings '>System Settings</Link>,
							},
							{
								key: "customize",
								icon: <SettingOutlined />,
								label: <Link to='/customize '>Theme Customizer</Link>,
							},
					  ]
					: []),
			],
		},
		filteredMenuItems.length > 0 && {
			key: "SETUP FIELDS",
			icon: <BranchesOutlined />,
			label: "SETUP FIELDS",
			popupClassName: "scrollable-submenu",
			children: renderMenuItems(filteredMenuItems),
		},
		filteredFormMenuItems.length > 0 && {
			key: "FORMS",
			icon: <FormOutlined />,
			label: "FORMS",
			popupClassName: "scrollable-submenu",
			children: renderMenuItems(filteredFormMenuItems),
		},
		filteredServiceDeskMenuItems.length > 0 && {
			key: "SERVICE DESK",
			icon: <BranchesOutlined />,
			label: "SERVICE DESK",
			children: renderMenuItems(filteredServiceDeskMenuItems),
		},
		{
			key: "logout",
			icon: <LogoutOutlined />,
			label: "Logout",
			onClick: handleLogout,
		},
		{
			key: "profile",
			icon: <EditFilled />,
			label: (
				<Link to='/profile' className='fs-16 mr-4'>
					profile
				</Link>
			),
		},
		{
			key: "password",
			icon: <LockFilled />,
			label: (
				<Link to='/password' className='fs-16 mr-4'>
					Password
				</Link>
			),
		},
	].filter(Boolean);

	return (
		<>
			<Layout hasSider>
				{/* FOR MOBILE */}
				{isMobile && !isMobileMenuOpen && (
					<Button
						icon={<MenuUnfoldOutlined />}
						onClick={() => setMobileMenuOpen(true)}
						style={{
							position: "fixed",
							top: 2,
							left: 2,
							zIndex: 2000,
						}}
					/>
				)}
				{/* FOR MOBILE */}

				{!isMobile && (
					<Sider trigger={null} collapsible collapsed={collapsed}>
						{!collapsed && (
							<>
								<div className='user-profile'>
									{currentUser && (
										<ProfilePictureComponent
											user_id={currentUser?.user_id}
											size={80}
										/>
									)}
									<div className='mt-10'>
										<Typography className='mb-10'>
											{currentUser?.name}
										</Typography>
										<small>
											<Tooltip title='Edit Profile'>
												<Link to='/profile' className='fs-16 mr-4'>
													<EditFilled />
												</Link>
											</Tooltip>
										</small>
										<small>
											<Tooltip title='Change Password'>
												<Link to='/password' className='fs-16 mr-4'>
													<LockFilled />
												</Link>
											</Tooltip>
										</small>
										<small>
											<Tooltip title='Logout'>
												<Link className='fs-16 mr-4' onClick={handleLogout}>
													<LogoutOutlined />
												</Link>
											</Tooltip>
										</small>
									</div>

									{impersonateUser && (
										<div className='mt-10 mb-0'>
											<Button
												icon={<SwapOutlined />}
												onClick={() => switchBack()}
												style={{
													width: "auto",
													height: 30,
												}}
											>
												Switch Back
											</Button>
										</div>
									)}

									{currentUser?.roles?.includes("admin") &&
										!impersonateUser && (
											<div className='mt-10 mb-0'>
												<Button
													icon={<SwapOutlined />}
													onClick={() => navigate("/switch-user")}
													style={{
														width: "auto",
														height: 30,
													}}
												>
													Switch User
												</Button>
											</div>
										)}
								</div>
							</>
						)}

						<Menu selectedKeys={[location.pathname]} items={desktopMenuItems} />
						<Menu items={serviceDeskMenu} />
						{collapsed && <Menu items={collapsedMenuItems} />}
						{!isMobile && (
							<Button
								type='text'
								className={isVisible === true ? "" : "menuButton"}
								icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
								onClick={() => setCollapsed(!collapsed)}
								style={{
									fontSize: "16px",
									width: 30,
									height: 30,
									position: "absolute",
								}}
							/>
						)}
					</Sider>
				)}

				<Content
					style={{
						padding: "0 0px 0 0",
						minHeight: "100% !important",
					}}
				>
					{children}
				</Content>
			</Layout>

			{isMobile && isMobileMenuOpen && (
				<div
					style={{
						position: "fixed",
						top: 0,
						left: 0,
						width: "90vw",
						height: "100vh",
						background: "#001529", // Antd Sider color
						zIndex: 1999,
						padding: "10px 0px",
						overflowY: "auto",
						color: "#fff",
					}}
				>
					<Button
						icon={<MenuFoldOutlined />}
						onClick={() => setMobileMenuOpen(false)}
						style={{
							position: "absolute",
							top: 16,
							right: 16,
							zIndex: 2001,
						}}
					/>
					<Menu
						theme='dark'
						mode='inline'
						defaultSelectedKeys={[location.pathname]}
						style={{ borderRight: 0 }}
						onClick={() => setMobileMenuOpen(false)}
						items={mobileMenuItems}
					/>
				</div>
			)}
		</>
	);
};

export default DefaultLayout;
